var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-tag-box",style:({height: _vm.domHieght/3.75 + 'vw'})},[_c('div',{staticClass:"tag",style:({color:_vm.txtColor,background:_vm.bgColor,border: '0.3vw solid' +  _vm.border,lineHeight: _vm.domHieght/3.75 + 'vw'})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }